// Lazy-loads the Tally embed script on first user intent (hover or click)
// to keep it out of the critical render path.
let loaded = false;
let loading: Promise<void> | null = null;

export function loadTally(): Promise<void> {
  if (loaded) return Promise.resolve();
  if (loading) return loading;
  loading = new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = "https://tally.so/widgets/embed.js";
    s.async = true;
    s.onload = () => {
      loaded = true;
      // Tally auto-binds to elements with data-tally-open on script load.
      resolve();
    };
    s.onerror = () => resolve();
    document.head.appendChild(s);
  });
  return loading;
}

let installed = false;
export function installTallyLazy() {
  if (installed || typeof window === "undefined") return;
  installed = true;

  const trigger = () => {
    loadTally();
    window.removeEventListener("pointerdown", trigger);
    window.removeEventListener("pointerover", onHover);
    window.removeEventListener("touchstart", trigger);
    window.removeEventListener("scroll", trigger);
  };
  const onHover = (e: PointerEvent) => {
    const t = e.target as HTMLElement | null;
    if (t && t.closest && t.closest("[data-tally-open]")) trigger();
  };
  window.addEventListener("pointerover", onHover, { passive: true });
  window.addEventListener("pointerdown", trigger, { passive: true });
  window.addEventListener("touchstart", trigger, { passive: true });
  // Safety net: load on first scroll past 1s
  setTimeout(() => window.addEventListener("scroll", trigger, { passive: true, once: true }), 1000);
}
